import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters([
            'themeDisableDarkMode',
        ]),
        unifiedIsThemeDark() {
            if (this.themeDisableDarkMode) {
                return false
            }
            return process.env.VUE_APP_THEME == 'dark'
        }
    }
};